// pages/mobile/icons.js
// Stroke icons from the mobile mockups. Decorative: always aria-hidden.
import React from 'react';

const Icon = ({ size = 20, strokeWidth = 2, children }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {children}
  </svg>
);

export const BackIcon = () => <Icon size={22}><path d="M15 6l-6 6 6 6" /></Icon>;
export const CheckIcon = ({ size = 20 }) => <Icon size={size} strokeWidth={2.6}><path d="M5 12l5 5 9-10" /></Icon>;
export const NavigateIcon = () => <Icon><path d="M3 11l18-8-8 18-2-8-8-2z" /></Icon>;
export const PinIcon = ({ size = 22 }) => (
  <Icon size={size}><path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" /></Icon>
);
export const WarningIcon = ({ size = 22 }) => (
  <Icon size={size}><path d="M10.3 3.9L1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" /><path d="M12 9v4M12 17h.01" /></Icon>
);
export const TruckIcon = ({ size = 22 }) => (
  <Icon size={size} strokeWidth={1.8}>
    <rect x="2" y="9" width="13" height="7" rx="1" /><path d="M15 11h4l3 3v2h-7" />
    <circle cx="6" cy="18" r="2" /><circle cx="18" cy="18" r="2" />
  </Icon>
);
export const PlowIcon = () => <Icon size={22} strokeWidth={1.8}><path d="M3 18h18M5 18l2-8h10l2 8" /><path d="M9 10V6h6v4" /></Icon>;
export const PeopleIcon = () => (
  <Icon size={22} strokeWidth={1.8}>
    <circle cx="9" cy="8" r="3" /><circle cx="17" cy="9" r="2.5" />
    <path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6M15 14.5c3 0 5.5 2.2 5.5 5.5" />
  </Icon>
);
export const StandDownIcon = () => <Icon size={22}><circle cx="12" cy="12" r="9" /><path d="M8 12h8" /></Icon>;
export const InboxIcon = () => (
  <Icon size={22}>
    <path d="M22 12h-6l-2 3h-4l-2-3H2" />
    <path d="M5.5 5.1L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.5-6.9A2 2 0 0 0 16.8 4H7.2a2 2 0 0 0-1.7 1.1z" />
  </Icon>
);
export const PersonIcon = () => <Icon size={22} strokeWidth={1.8}><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4.4 3.6-8 8-8s8 3.6 8 8" /></Icon>;
export const BellIcon = ({ size = 18 }) => (
  <Icon size={size}><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" /><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" /></Icon>
);
export const DownloadIcon = () => <Icon size={18}><path d="M12 3v12M7 10l5 5 5-5" /><path d="M5 21h14" /></Icon>;
export const ShareIcon = () => (
  <Icon size={22} strokeWidth={1.8}>
    <path d="M12 3v12M8 7l4-4 4 4" /><path d="M6 11H5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-1" />
  </Icon>
);
export const AddSquareIcon = () => (
  <Icon size={22} strokeWidth={1.8}><rect x="4" y="4" width="16" height="16" rx="3" /><path d="M12 8v8M8 12h8" /></Icon>
);
export const InfoIcon = () => <Icon size={18}><circle cx="12" cy="12" r="9" /><path d="M12 8v5M12 16h.01" /></Icon>;
